import { Bounce, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export function Notification(type = "info", title, position) {
  // toast.dismiss();
  return toast(title, {
    type,
    position: position || "top-center",
    limit: 1,
    autoClose: 4000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
    className: "toast-container",
  });
}
// Zoom